import { render, staticRenderFns } from "./LoadHeader.vue?vue&type=template&id=272f3f9a&scoped=true"
import script from "./LoadHeader.vue?vue&type=script&lang=ts"
export * from "./LoadHeader.vue?vue&type=script&lang=ts"
import style0 from "./LoadHeader.vue?vue&type=style&index=0&id=272f3f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272f3f9a",
  null
  
)

export default component.exports